module.exports = __webpack_public_path__ + "static/media/inspection-dvir.941947a1.svg";